var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { useField } from '../../Components/useForm/useField';
import { MedicationStatus } from '../../Contracts/MedicationModels';
import { EditMedicationInfoLine } from './EditMedicationInfoLine';
import styles from './EditMedicationTitle.module.css';
export var Fields;
(function (Fields) {
    Fields["Name"] = "Name";
    Fields["Date"] = "Date";
    Fields["Time"] = "Time";
    Fields["ViewingRight"] = "ViewingRight";
})(Fields || (Fields = {}));
export function EditMedicationTitle(props) {
    var _a, _b;
    var _c = __read(useState(null), 2), inputFocus = _c[0], setInputFocus = _c[1];
    var autosaveInputRef = useRef(null);
    var timeout = useRef(null);
    var nameField = useField({ form: props.form, field: 'name' });
    var performedOnField = useField({ form: props.form, field: 'performedOn' });
    var focusField = function (field) { return function () {
        if (props.readOnly)
            return;
        if (timeout.current)
            clearTimeout(timeout.current);
        if (inputFocus === null)
            setInputFocus(field);
    }; };
    var blurField = function () {
        timeout.current = setTimeout(function () {
            if (inputFocus !== null)
                setInputFocus(null);
        }, 0);
    };
    var handleEditClick = function () {
        if (props.readOnly)
            return;
        if (timeout.current)
            clearTimeout(timeout.current);
        setInputFocus(Fields.Name);
        var input = autosaveInputRef.current;
        if (autosaveInputRef && input && input.focus)
            input.focus();
    };
    var inputEditMode = !!inputFocus || !!performedOnField.error;
    var mainlineClass = classNames(styles.mainline, (_a = {},
        _a[styles.focused] = inputEditMode,
        _a[styles.clickable] = !props.readOnly,
        _a));
    var containerClasses = classNames(styles.container, (_b = {},
        _b[styles.problemsAndViewingRightsHidden] = props.problemsAndViewingRightsHidden,
        _b));
    var evaluateProvider = function () {
        var _a, _b;
        if (props.patientMedication.status !== MedicationStatus.Finalised ||
            props.patientMedication.verbalOrderDetail !== null)
            return (_a = props.patientMedication.service) === null || _a === void 0 ? void 0 : _a.primaryProvider;
        return (_b = props.patientMedication.finalisedDetail) === null || _b === void 0 ? void 0 : _b.prescribedBy;
    };
    return (React.createElement("div", { className: containerClasses },
        React.createElement("div", { className: styles.information },
            React.createElement("div", { className: mainlineClass },
                React.createElement("div", { className: styles.title }, nameField.value)),
            React.createElement(EditMedicationInfoLine, { form: props.form, provider: evaluateProvider(), inputEditMode: inputEditMode, focusedField: inputFocus, readOnly: props.readOnly, onFieldClick: focusField, onFieldFocus: focusField, onFieldBlur: blurField, onEditButtonClick: handleEditClick }))));
}
